import { render, staticRenderFns } from "./NPSBAQuestion.vue?vue&type=template&id=23d93554&scoped=true&"
import script from "./NPSBAQuestion.vue?vue&type=script&lang=js&"
export * from "./NPSBAQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NPSBAQuestion.vue?vue&type=style&index=0&id=23d93554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d93554",
  null
  
)

export default component.exports